import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`

:root{
    /* Core palette (Black/Gold) */
    --bg: #07060a;
    --bg-rgb: 7, 6, 10;
    --surface-1: #0c0b12;
    --surface-1-rgb: 12, 11, 18;
    --surface-2: #12111a;
    --surface-2-rgb: 18, 17, 26;

    --white: #ffffff;
    --text: rgba(255, 255, 255, 0.92);
    --muted: rgba(255, 255, 255, 0.70);
    --muted-2: rgba(255, 255, 255, 0.56);

    --gold: #d4af37;
    --gold-rgb: 212, 175, 55;
    --gold-2: #f0d58a;
    --gold-2-rgb: 240, 213, 138;

    --border: rgba(255, 255, 255, 0.12);
    --border-2: rgba(255, 255, 255, 0.08);

    --shadow-1: 0 22px 60px rgba(0, 0, 0, 0.55);
    --shadow-2: 0 14px 34px rgba(0, 0, 0, 0.45);

    --radius-sm: 12px;
    --radius-md: 16px;
    --radius-lg: 20px;

    --container: 1160px;

    /* Typography */
    --font-sans: Inter, system-ui, -apple-system, Segoe UI, Roboto, Arial, "Noto Sans", "Liberation Sans", sans-serif;
    --font-display: "Space Grotesk", var(--font-sans);

    /* Legacy aliases (kept to avoid cascading breakage) */
    --background: var(--bg);
    --black: var(--bg);
    --nav: var(--surface-2);
    --nav2: var(--muted);
    --purple: var(--gold);
    --pink: var(--gold-2);
}


*,*::before,*::after{
    margin:0;
    padding:0;
    box-sizing:border-box;
        font-family: var(--font-sans);
}
html{
  ${"" /* overflow-y: scroll; */}
  scroll-behavior:smooth;
    color-scheme: dark;
  
}
    body,
    html,
    a {
                font-family: var(--font-sans);
            }
    body {

        margin:0;
        padding:0;
        border: 0;
        outline: 0;
                color: var(--text);
                background:
                    radial-gradient(1200px 640px at 50% -10%, rgba(var(--gold-rgb), 0.16), transparent 60%),
                    radial-gradient(900px 520px at 90% 20%, rgba(var(--gold-rgb), 0.08), transparent 62%),
                    radial-gradient(980px 520px at 15% 40%, rgba(var(--surface-1-rgb), 0.35), transparent 65%),
                    var(--background);

        overflow-x: hidden;
                -webkit-font-smoothing: antialiased;
                -moz-osx-font-smoothing: grayscale;
                text-rendering: optimizeLegibility;
    }
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        margin:0;
        padding:0;
        font-family: var(--font-display);
        letter-spacing: -0.02em;
    }
    a {

        text-decoration: none;
        outline: none;
        color: inherit;
    }
    button{
        border:none;
        outline:none;
        &:focus{
            outline:none;
        }
    }

    /* Accessible focus: keep it visible for keyboard users */
    :focus {
        outline: none;
    }
    :focus-visible {
        outline: 2px solid rgba(var(--gold-rgb), 0.9);
        outline-offset: 3px;
    }

    img,svg{
        width:100%;
        height:auto;
    }

    ::selection {
      background: rgba(var(--gold-rgb), 0.24);
      color: var(--white);
    }

    @media (prefers-reduced-motion: reduce) {
      html { scroll-behavior: auto; }
      *, *::before, *::after {
        animation-duration: 0.001ms !important;
        animation-iteration-count: 1 !important;
        transition-duration: 0.001ms !important;
        scroll-behavior: auto !important;
      }
    }


`;

//  /* Colors */
